module.exports = __webpack_public_path__ + "img/中南民族大学.426bdd6b.png";